<template>

    <div class="table__wrapper">

        <div> DEPRECATED?? DEPREDATEDDDDDD </div>

        <table>
          <thead>
            <tr>
              <th v-for="(myCol, colix) in tabledata.columns" :key="colix">
                  {{ myCol.name ? myCol.name : myCol.field }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, rowix) in tabledata.items" :key="rowix" :class="item.status">
              <td v-for="(rowCol, rowcolix) in tabledata.columns" :key="rowcolix" :class="item.type">
                  {{ item[rowCol.field] }}
              </td>
              <td>
                Actions
              </td>
            </tr>
          </tbody>
        </table>
    </div>

</template>

<style lang="scss" scoped >

</style>

<script>
    export default {

        props: [
            'tabledata',
        ],
    }

</script>